// import { countdownDSA } from './countdownDSA'
// import { newModalGrupo } from './countdownDSA'




export function initialScript() {
  window.DFI_client = {}

  window.DFI_client.requestCoursePriority = function (id) {
    const coursesPriority = [
      '035',
      '040',
      '042',
      '043',
      '046',
      '047',
      '065',
      '066',
      '072',
      '073',
      '075',
      '077',
      '131',
      '132',
      '291',
      '386',
      '756',
      '757',
      '758',
      '759',
      '945',
      '946',
      '947',
      '950',
      '080',
      '099',
      '143',
      '627',
      '509',
      '383',
      '677',
      '129',
      '148',
      '144',
      '290',
      '029',
      '149',
      '543',
      '699',
      '382',
      '387',
      '754',
      '130',
      '154',
      '714',
      '096',
      '755',
      '085',
      '063',
      '064',
      '074',
      '188',
      '038',
      '718',
      '715',
      '717',
      '716',
      '134',
      '034',
      '079',
      '062'
    ]

    let output = false
    coursesPriority.forEach((key) => {
      if (key === id) {
        output = true
      }
    })

    return output
  }

  window.DFI_client.walmericUrl =
    window.location.protocol +
    '//' +
    window.location.hostname +
    window.location.pathname

  if (
    window.DFI_client.walmericUrl.charAt(
      window.DFI_client.walmericUrl.length - 1
    ) === '/'
  ) {
    window.DFI_client.walmericUrl = window.DFI_client.walmericUrl.substr(
      0,
      window.DFI_client.walmericUrl.length - 1
    )
  }

  window.DFI_client.walmericUrlWithModal = [
    'http://localhost:8080',
    'https://dev-ifp-dev.ed-integrations.com',
    'https://qa-ifp-dev.ed-integrations.com',
    'https://pre-ifp-dev.ed-integrations.com',
    'https://qasb.ifp.es',
    'https://devsb.ifp.es',
    'https://presb.ifp.es',
    'https://dev.pre.ifp.es',
    'https://pre.pre.ifp.es',
    'https://delio-lm.com/delio-lite/delio-lm/test_landing/demo_planeta'
  ]

  try {
    window.DFI_client.walmericUrlWithModal.forEach(function (item, index, arr) {
      if (window.DFI_client.walmericUrl === item) {
        window.walmericDatalayer = { modal: 'si' }
        throw 'Break'
      } else {
        window.walmericDatalayer = { modal: 'no' }
      }
    })
  } catch (err) {
    if (err !== 'Break') throw err
  }

  if (typeof window.idTagDelio === 'undefined') {
    window.idTagDelio =
      '29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953a917d1d3e6631f9232ab32e8c877a9672304861cd19abb320c0a403f7d4843f9530addbc1b1a4d1f6d9de22d322d90793267e5b1d7e7a9a8127bfd4b06acf4477b0904d61ee4aca9428bf3d3ef5185ac7'
  }

  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = 'https://t.womtp.com/slider/c/delio-lm/dfi/init.js'
  const head = document.getElementsByTagName('head')[0]
  head.appendChild(script)

  // countdownDSA()
  // newModalGrupo()
  // console.log("primera entrada")
}
